// eslint-disable-next-line filenames/match-regex,folders/match-regex
import {Text} from '@rdcomponents/text/text';
import {memo, ReactElement, useEffect, useRef, useState} from 'react';

import {useLocale} from '../../../../../provider/locale/locale-hook';
import {useMessage} from '../../../../../provider/message/message-hook';
import {classNames} from '../../../../../util/css';

import * as styles from './answerTimer.scss';

type AnswerTimerPropsType = {
    expiresAt: string;
    now: number;
    onExpire?: () => void;
    onTimeIsUp?: () => void;
};

export const AnswerTimer = memo(function AnswerTimerInner(props: AnswerTimerPropsType): ReactElement | null {
    const {expiresAt, now, onExpire, onTimeIsUp} = props;
    const calledRef = useRef(false);
    const {getLocalizedString} = useLocale();
    const {message} = useMessage();
    const [showExpiredMessage, setShowExpiredMessage] = useState(false);

    const diff = new Date(expiresAt || '').getTime() - now;

    const totalSeconds = Math.max(0, Math.floor(diff / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout> | null = null;

        if (totalSeconds <= 0 && !calledRef.current) {
            calledRef.current = true;
            onTimeIsUp?.();
            setShowExpiredMessage(true);

            timer = setTimeout(() => {
                message.info(getLocalizedString('REVIEW__ANSWER_TIMER__MESSAGE'));
                setShowExpiredMessage(false);
                onExpire?.();
            }, 3000);
        }

        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [totalSeconds]);

    if (showExpiredMessage) {
        return <Text className={styles.AnswerTimer_gray} secondary stringKey="REVIEW__ANSWER_TIMER__EXPIRED_BLOCK" />;
    }

    const colorClass = classNames(styles.AnswerTimer_gray, {
        [styles.AnswerTimer_red]: totalSeconds < 60,
        [styles.AnswerTimer_yellow]: totalSeconds >= 60 && totalSeconds < 180,
    });

    return (
        <Text
            secondary
            stringKey="REVIEW__ANSWER_TIMER__DESCRIPTION"
            valueMap={{
                time: (
                    <Text bolder className={colorClass}>
                        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
                    </Text>
                ),
            }}
        />
    );
});
